import { render, staticRenderFns } from "./FaqUsers.vue?vue&type=template&id=54c15538&lang=pug&"
import script from "./FaqUsers.vue?vue&type=script&lang=js&"
export * from "./FaqUsers.vue?vue&type=script&lang=js&"
import style0 from "./FaqUsers.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports